import { Flex, Paper, Text, useMantineTheme } from '@mantine/core';
import { ComponentPropsWithoutRef } from 'react';

import { useAppColorScheme } from '@/shared/lib/hooks/use-app-color-scheme';
import { useCITypeMapStorage } from '../model/ci-type-map-storage';

interface CiTypeIconProps extends ComponentPropsWithoutRef<'img'> {
  size?: number | string;
}

export function CITypeIcon({ src }: CiTypeIconProps) {
  const theme = useMantineTheme();
  const colorScheme = useAppColorScheme();
  return (
    <Paper
      shadow='xs'
      radius='sm'
      withBorder
      style={
        colorScheme === 'dark'
          ? { backgroundColor: theme.colors.dark[2] }
          : { backgroundColor: theme.colors.dark[1] }
      }
      classNames={{ root: 'overflow-hidden h-[24px] w-[24px] shrink-0' }}
    >
      <img src={src} className={'h-full w-full p-0.5'} />
    </Paper>
  );
}

export const CiTypeRender = ({ name }: { name: string }) => {
  const { data: ciTypeMap } = useCITypeMapStorage();
  return (
    <Flex align={'center'} wrap={'nowrap'} gap={'xs'}>
      <CITypeIcon size={16} src={ciTypeMap.get(name)?.icon} />{' '}
      <Text>{ciTypeMap.get(name)?.label}</Text>
    </Flex>
  );
};